import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;

// On Cloudflare Pages (production), the build pipeline prerenders each route
// and stamps `data-prerendered="true"` on <div id="root">. We hydrate.
//
// On the Lovable preview/dev server there is no prerender — the static shell
// in index.html is just a placeholder, so we mount fresh with createRoot to
// avoid hydration mismatches.
const isPrerendered = container.getAttribute("data-prerendered") === "true";

if (isPrerendered) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
